import api from '../../services/api';
import { CHILDREN_PAGE_SIZE, SEARCH_PAGE_SIZE } from './orgChartModel';

export const ORG_CHART_URL = '/v1/org-chart';
export const POSITION_NOT_FOUND = 'orgChart.positionNotFound';
export const BRANCH_TOO_LARGE = 'orgChart.branchTooLarge';

/**
 * `api.js` GET okumalarında ASLA reject etmez; hata `{ status: false }` olarak ÇÖZÜLÜR. Durum `status` bayrağından çıkar:
 * 'ok' | 'notFound' | 'tooLarge' | 'error'. "Yüklenemedi" ile "boş" ayrı durumlardır (`.catch()` ölü kod olurdu).
 */
export function parseResponse(res) {
  const body = res?.data;
  if (body?.status === true && body.data) return { state: 'ok', data: body.data };
  if (body?.message === POSITION_NOT_FOUND) return { state: 'notFound' };
  if (body?.message === BRANCH_TOO_LARGE) return { state: 'tooLarge' };
  return { state: 'error' };
}

// 404 odak (paylaşılan bağlantı, silinmiş/görünmeyen pozisyon) ve 400 "Tümü" sınırı (büyümüş dala paylaşılan depth=all
// bağlantısı, projeksiyon dolmadan seçilen Tümü): toast bastırılır, gövde geçirilir — sayfa kendi bilgi şeridini gösterip
// kendi pozisyonuna / 1. seviyeye döner (çift mesaj yok, çıkışsız hata ekranı yok).
// `via`: geldiğimiz GÖRÜNÜR odak — hedef onun atasıysa (Bir Üste Çık, kırıntı) projeksiyon gecikirken de açılır.
// `reveal` (spec 2026-10-24 §8.1): kök görünümünde kökten bu pozisyona (ya da `me`) giden yol açık gelir.
export async function fetchView({ focus, depth, edit, expand, via, reveal } = {}) {
  const params = { focus: focus || 'me', depth: depth || '1' };
  if (edit) params.edit = true;
  if (reveal) params.reveal = reveal;
  if (expand && expand.length) params.expand = expand.join(',');
  if (via) params.via = via;
  return parseResponse(await api.get(`${ORG_CHART_URL}/view`, {
    params, skipErrorToast: [POSITION_NOT_FOUND, BRANCH_TOO_LARGE], passErrorBody: true,
  }));
}

export async function fetchChildren(positionId, { edit = false, page = 1, pageSize = CHILDREN_PAGE_SIZE, via } = {}) {
  const params = { page, pageSize };
  if (edit) params.edit = true;
  if (via) params.via = via;
  return parseResponse(await api.get(`${ORG_CHART_URL}/nodes/${encodeURIComponent(positionId)}/children`, { params }));
}

export async function searchPositions({ q, page = 1, pageSize = SEARCH_PAGE_SIZE, edit = false } = {}) {
  const params = { q, page, pageSize };
  if (edit) params.edit = true;
  return parseResponse(await api.get(`${ORG_CHART_URL}/search`, { params }));
}

export async function fetchMyTeamSummary() {
  return parseResponse(await api.get(`${ORG_CHART_URL}/my-team-summary`));
}
